/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { COLORS } from "./merchants.constants";

export default function MerchantSliderControls({
  isArabic,
  onPrev,
  onNext,
}) {
  return (
    <>
      <button
        className="btn rounded-circle position-absolute d-flex align-items-center justify-content-center"
        style={{
          width: 42,
          height: 42,
          background: COLORS.gold,
          color: COLORS.darkPurple,
          border: "none",
          top: "50%",
          [isArabic ? "right" : "left"]: "-25px",
          transform: "translateY(-50%)",
        }}
        onClick={onPrev}
      >
        {isArabic ? <FaChevronRight /> : <FaChevronLeft />}
      </button>

      <button
        className="btn rounded-circle position-absolute d-flex align-items-center justify-content-center"
        style={{
          width: 42,
          height: 42,
          background: COLORS.gold,
          color: COLORS.darkPurple,
          border: "none",
          top: "50%",
          [isArabic ? "left" : "right"]: "-25px",
          transform: "translateY(-50%)",
        }}
        onClick={onNext}
      >
        {isArabic ? <FaChevronLeft /> : <FaChevronRight />}
      </button>
    </>
  );
}
